/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TCreateConsultationMessageModel = IModel<
  ICreateConsultationMessageRequest,
  TCreateConsultationMessageResponse
>;

export interface ICreateConsultationMessageRequest {
  /** Комментарий **/
  comment: string;
  /** Готов к сотрудничеству **/
  cooperationStatus: ECooperationStatus;
  /** E-mail **/
  email?: string | null;
  /** ФИО **/
  fullName?: string | null;
  /** Тестовая заявка **/
  isTest?: boolean | null;
  /** Телефон **/
  phone: string;
}

export type TCreateConsultationMessageResponse =
  | ICreateConsultationMessageResponse200
  | ICreateConsultationMessageResponse400;

export interface ICreateConsultationMessageResponse200 extends IModelResponse<ICreateConsultationMessageResponse> {
  statusCode: 200;
}

export interface ICreateConsultationMessageResponse400 extends IModelResponse<ICreateConsultationMessageResponseError> {
  statusCode: 400;
}

export interface ICreateConsultationMessageResponse {
  /** ID заявки **/
  id: number;
  /** Статус ответа **/
  status: EStatus;
}

export interface ICreateConsultationMessageResponseError {
  errors: any[];
  message: string;
}

export type TResponses = ICreateConsultationMessageResponse | ICreateConsultationMessageResponseError;

export enum EStatus {
  /** Запрос обработан успешно **/
  Ok = 'ok',
}

export enum ECooperationStatus {
  /** Решение будет после консультации **/
  AfterConsultation = 'afterConsultation',
  /** Нет **/
  No = 'no',
  /** Да **/
  Yes = 'yes',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: ICreateConsultationMessageResponse): TResponse200;
  400(response: ICreateConsultationMessageResponseError): TResponse400;
}
